/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component — «UI nuova» fork of NotAvailableLabel (M18
 *              ec-catalog): same hideLabel getter, nuova pill markup
 *   extends:   NotAvailableLabelComponent
 *   template:  not-available.hbs
 *   args:      @hideAddToChart, @product_status_id
 *   uses:      -
 *   siblings:  components/not-available-label.js (the classic it extends)
 *   tests:     ui-nuova-ec-catalog-test.js
 *
 * Rendered by ec-catalog-nuova/product-card.hbs.
 */
import NotAvailableLabelComponent from '../not-available-label';

export default class EcCatalogNuovaNotAvailableComponent extends NotAvailableLabelComponent {}
